export enum LinkspaceSection {
    AccommodationCityCapacities = 'accommodationCityCapacities',
    AccommodationPois = 'accommodationPois',
    CityAdaptedOptions = 'cityAdaptedOptions',
    CityCategory = 'cityCategory',
    CityCategoryAdaptedOptions = 'cityCategoryAdaptedOptions',
    CityCategoryPopularNearby = 'cityCategoryPopularNearby',
    CityCategoryWithNearbyCityByPriceDesc = 'cityCategoryWithNearbyCityByPriceDesc',
    CityPictogram = 'cityPictogram',
    CityPois = 'cityPois',
    CityPopularNearby = 'cityPopularNearby',
    CityRegion = 'cityRegion',
    CityRegionsCategory = 'cityRegionsCategory',
    CityWithCategoryByPriceDesc = 'cityWithCategoryByPriceDesc',
    CityWithNearbyCityByPriceDesc = 'cityWithNearbyCityByPriceDesc',
    CountryAdaptedOptions = 'countryAdaptedOptions',
    CountryCategory = 'countryCategory',
    CountryCategoryPopularNearby = 'countryCategoryPopularNearby',
    CountryCategoryRegions = 'countryCategoryRegions',
    CountryCategoryVoivodeships = 'countryCategoryVoivodeships',
    CountryPictogram = 'countryPictogram',
    CountryPictogramPopular = 'countryPictogramPopular',
    CountryPictogramRegion = 'countryPictogramRegion',
    CountryPictogramVoivodeship = 'countryPictogramVoivodeship',
    CountryPopularNearby = 'countryPopularNearby',
    CountryRegions = 'countryRegions',
    CountryVoivodeship = 'countryVoivodeship',
    OtherAccommodationOptions = 'otherAccommodationOptions',
    NearbyAccommodations = 'nearbyAccommodations',
    RegionAdaptedOptions = 'regionAdaptedOptions',
    RegionCategory = 'regionCategory',
    RegionCategoryPopular = 'regionCategoryPopular ',
    RegionPictogram = 'regionPictogram',
    RegionPopularNearby = 'regionPopularNearby',
    RegionWithPopularCitiesByPriceDesc = 'regionWithPopularCitiesByPriceDesc',
    VoivodeshipWithCategory = 'voivodeshipWithCategory',
    VoivodeshipWithCheapOption = 'voivodeshipWithCheapOption',
    VoivodeshipWithPictogram = 'voivodeshipWithPictogram',
    VoivodeshipWithPopularCities = 'voivodeshipWithPopularCities',
}
